<template>
	<div
		class="car-tag-list"
		:class="theme"
		:style="{ maxHeight: height, ...listStyle }"
		ref="tagList"
	>
		<div v-for="tag in tags" class="car-tag" :class="{ ['type_' + tag.type]: true, [theme]: true }">
			<span>{{ tag.label }}</span>
		</div>
	</div>
</template>

<script>
export const businessTypeMapTag = {
	1: { label: '官方车源', type: 'b2c' },
	2: { label: '个人车主', type: 'c2c' },
	4: { label: '车商直售', type: 'c2c' }
}
export const getBusinessTypeLabel = businessType => {
	switch (businessType) {
		case 1:
			return '官方车源'
		case 2:
			return '个人车主'
		case 4:
			return '车商直售'
	}
}
export default {
	name: 'CarTags',
	props: {
		tags: {
			type: Array,
			required: true
		},
		theme: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			inScroll: false,

			lastMovePos: null
		}
	},
	computed: {
		line() {
			return this.theme === 'large' ? 2 : 1
		},
		listStyle() {
			if (this.line === null) {
				return {}
			}
			return {
				display: 'flex',
				'flex-wrap': 'wrap'
			}
		},
		height() {
			if (this.line === null) {
				return 'auto'
			}
			return (this.line * 32) / 3.75 + 'vw'
		}
	},
	mounted() {
		this.onTagsChanged()
	},
	methods: {
		onTagsChanged() {
			if (this.line === null) {
				return
			}
			let $latest = null
			for (let index = 0; index < this.$refs.tagList.childNodes.length; index += 1) {
				const $item = this.$refs.tagList.childNodes.item(index)
				$item.classList.remove('latest')
				if ($item.offsetTop >= this.$refs.tagList.clientHeight && !$latest) {
					$latest = $item
				}
			}

			if ($latest) {
				$latest.classList.add('latest')
			}
		}
	},
	watch: {
		inScroll(val) {
			if (val) {
				this.$emit('scrollStart')
			} else {
				this.$emit('scrollEnd')
			}
		},
		tags() {
			this.$nextTick(() => {
				this.onTagsChanged()
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.car-tag-list {
	overflow: hidden;
	@include body_3(1.5, 400, false);
	white-space: normal;
	word-break: break-word;
	position: relative;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	overflow: hidden;

	.car-tag {
		display: inline-flex;
		padding: 0 5px;

		margin-bottom: 10px;
		margin-right: 5px;
		word-break: break-all;
		flex-shrink: 0;
		flex-grow: 0;
		height: 21px;

		background: #f7f7f8;
		color: #696d7f;
		align-items: center;

		&.normal {
		}

		&.large {
			padding: 0 8px;
			height: 25px;
		}
		&.latest {
			margin-right: 0;
			padding-right: 0;
			flex: 1;
			position: relative;

			> span {
				display: -webkit-box;
				-webkit-line-clamp: 1;
				text-overflow: ellipsis;
				-webkit-box-orient: vertical;
				overflow-y: hidden;
			}
		}

		&.type_b2c {
			color: #ffffff;
			background: #122d59;
		}

		&.type_c2c {
			background: #ebecf0;
			color: #424757;
		}

		&.type_1 {
			background: #f9f4f0;
			color: #af7e55;
		}

		&.type_2 {
			background: #f3ece8;
			color: #d27456;
		}

		&.type_3 {
			background: #f7f7f8;
			color: #696d7f;
		}

		&.type_4 {
			background: #fffaed;
			color: #c76e0a;
		}

		&.green {
			background-color: #f2feff;
			color: #00bebe;
		}

		&.orange {
			background-color: #fffaeb;
			color: #ed911c;
		}
	}
}
</style>
